import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "@/index.css";
import App from "@/App";

// CRA/webpack overlay — ResizeObserver + ESLint false positives (büyük App.js)
const RO_LOOP =
  /ResizeObserver loop (completed with undelivered notifications|limit exceeded)/;
const ESLINT_PARSE_NOISE =
  /\[eslint\][\s\S]*Parsing error: Unterminated JSX contents/;
window.addEventListener(
  "error",
  (event) => {
    const msg = event.message || "";
    if (RO_LOOP.test(msg) || ESLINT_PARSE_NOISE.test(msg)) {
      event.stopImmediatePropagation();
    }
  },
  true
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
